export default __webpack_public_path__ + "static/media/mobilesde.693af772.svg";